/* eslint-disable react/no-array-index-key */
import React, { type ReactElement, Fragment } from 'react';

import classnames from 'classnames';

import styles from './HighLight.module.scss';

type HighLightProps = {
    className?: string;
    highLightClassName?: string;
    text: string;
    suffix?: string;
    highlight?: string;
};

// Search special characters, replace them with a backslash followed by the character
const escape = (str: string) => str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export const normalizeString = (str = '') => {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};

const compareAndSplitText = (text: string, highlight: string) => {
    const normalizedText = normalizeString(text);
    const normalizedHighlight = normalizeString(escape(highlight));

    const regex = new RegExp(`(\\b${normalizedHighlight}|(?=\\W)${normalizedHighlight})`, 'gi');

    const parts = normalizedText.split(regex);

    return parts.map((part, index) => {
        const start = parts.slice(0, index).join('').length;
        return text.slice(start, start + part.length);
    });
};

export const HighLight = ({
    className,
    highLightClassName,
    text,
    suffix,
    highlight
}: HighLightProps): ReactElement => {
    if (!highlight)
        return (
            <>
                {text} {suffix}
            </>
        );

    const parts = compareAndSplitText(text, highlight);

    return (
        <span className={className}>
            {parts.map((part, key) => (
                <Fragment key={key}>
                    {normalizeString(part) === normalizeString(highlight) ? (
                        <em
                            aria-label="highlight"
                            className={classnames(styles.highLight, highLightClassName)}
                        >
                            {part}
                        </em>
                    ) : (
                        part
                    )}
                </Fragment>
            ))}
            {suffix}
        </span>
    );
};
